import { findIndex, union } from "lodash/array";
import { find, map } from "lodash/collection";

/**
 * Return array index depends upon condition
 * @param {*} arr 
 * @param {*} condition 
 * @returns 
 */
function getArrayIndex(arr, condition) {
	return findIndex(arr, condition);
}

/**
 * Return array object depends upon condition
 * @param {*} arr 
 * @param {*} condition 
 * @returns 
 */
function getArrayObject(arr, condition) {
	return find(arr, condition);
}

/**
 * Return values array depends upon id
 * @param {*} arr 
 * @param {*} id 
 * @returns 
 */
function getAllValuesOfId(arr = [], id) {
	return union([], map(arr, id));
}

export { getArrayIndex, getArrayObject, getAllValuesOfId };
